import Env from '../base/env'

export default class MainTransition
{
    constructor()
    {
        this.view = Env.$mainTransition
        this.settings = { easing : Power2.easeInOut , duration : 1 }
        this.direction = false
        this.status = false
        this.setDirection(-1)
    }

    getStatus()
    {
        return this.status
    }


    in(funcStart='',funcComplete='')
    {
        const viewport = Env.framework.toolbox.getViewport()
        let timeline = new TimelineLite({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'in'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            TweenLite.fromTo(Env.$mainTransitionProgress , .5 , { clip : `rect(${viewport.height}px,${viewport.width}px,${viewport.height}px,0px)` } , { clip : `rect(0px,${viewport.width}px,${viewport.height}px,0px)` , ease : Power3.easeInOut }),
            TweenMax.fromTo(this.view , this.settings.duration,
                {
                    autoAlpha : 0
                },
                {
                    autoAlpha : 1,
                    ease: this.settings.easing,
                    delay: 0,
                }
            )
        ])
    }

    out(funcStart='',funcComplete='')
    {
        const viewport = Env.framework.toolbox.getViewport()
        let timeline = new TimelineLite({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'out'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })
        const goTo = (this.direction > 0)?'100%':'-100%'

        timeline.add([
            TweenLite.fromTo(Env.$mainTransitionProgress , .5 , { clip : `rect(0px,${viewport.width}px,${viewport.height}px,0px)` } , { clip : `rect(0px,${viewport.width}px,0px,0px)` , ease : Power3.easeInOut })
        ])
        timeline.add([
            TweenMax.fromTo(this.view , 1,
                {
                    autoAlpha : 1
                },
                {
                    autoAlpha : 0,
                    ease: this.settings.easing,
                    delay: 0,
                }
            )
        ],'-=.25')
    }

    setDirection(value)
    {
        this.direction = value
    }
}


// WEBPACK FOOTER //
// ./resources/js/transition/TransitionMain.js